"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MusicIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.994 10.676V.892a.901.901 0 00-.68-.868.863.863 0 00-.389-.004L6.044 1.799a.874.874 0 00-.493.314.898.898 0 00-.19.558v7.418a3.013 3.013 0 00-1.919-.234 3.046 3.046 0 00-1.673.982 3.142 3.142 0 00-.3 3.712 3.067 3.067 0 001.493 1.245c.618.24 1.295.271 1.93.087a3.055 3.055 0 001.597-1.106c.4-.534.619-1.186.623-1.858a3.94 3.94 0 000-.462V3.382l6.13-1.378V8.31a3.013 3.013 0 00-1.92-.234 3.046 3.046 0 00-1.673.983 3.142 3.142 0 00-.296 3.714 3.068 3.068 0 001.496 1.244c.618.24 1.296.269 1.931.084a3.056 3.056 0 001.595-1.111 3.14 3.14 0 00.619-1.86 4.135 4.135 0 000-.454z"
  })))
});
MusicIcon.displayName = 'MusicIcon';
var _default = exports.default = MusicIcon;